import { dissoc } from 'ramda'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import LazyAction from './LazyAction'
import PaginationBar from './PaginationBar'

const PaginationControl = ({ onChange, page, fetchMore, state, disabled, isNumbered }) => {
  const numberedPagination = useSessionPermission('useNumberedPagination') || isNumbered

  React.useEffect(() => {
    if (numberedPagination && !disabled) onChange(1)
  }, [JSON.stringify(dissoc('page', state.variables))])

  if (disabled) return false

  if (numberedPagination) return <PaginationBar onChange={onChange} page={page} />

  return <LazyAction disabled={disabled} action={fetchMore} waiting={state.loading} />
}

export default PaginationControl
